import styled from 'styled-components/macro';
import { Button } from 'ui-component-library/components';
import { FlexNoAlign } from '../../../../../shared-styles/flex';

export const ButtonsContainer = styled.div`
  ${FlexNoAlign}
  padding: 0 ${({ theme }) => theme.spacing(20)};
  justify-content: space-around;
  padding-bottom: ${({ theme }) => theme.spacing(15)};
  padding-top: ${({ theme }) => theme.spacing(5)};
`;

export const ModalButton = styled(Button)`
  width: 201px;
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
  font-size: ${({ theme }) => theme.typography.sizes.base};
`;

export const TextContainer = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.small};
  margin-bottom: ${({ theme }) => theme.spacing(20)};
  padding: 0 60px;
  text-align: center;
`;
